module.exports = __webpack_public_path__ + "static/media/short-02.9ab80492.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pitch-deck/short/short-02.png
// module id = 2114
// module chunks = 0